import { initContract } from '@ts-rest/core';
import { adminCmsContract } from './cms.admin.contract';
import { publicCmsContract } from './cms.public.contract';

const c = initContract();

export const cmsContract = c.router(
  {
    public: publicCmsContract,
    admin: adminCmsContract,
  },
  {
    pathPrefix: '/cms',
    strictStatusCodes: true,
  },
);

export * from './cms.admin.contract';
export * from './cms.public.contract';
